import { Accordion, Box, ContentTemplate, KeyValue, SectionHeader } from 'web-library';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { CoordinatorProfileResponseObject } from 'web-library/models/AccountManagementConfiguration';
import { stringToSemanticDisplay } from 'web-library/utils/DateUtils';
import CoordinatorPersonalParticulars from '../../../../pages/userAccountManagement/CreateEditViewCoordinatorAccountDetails/CoordinatorPersonalParticulars';
import CoordinatorContactInformation from '../../../../pages/userAccountManagement/CreateEditViewCoordinatorAccountDetails/CoordinatorContactInformation';

export interface CoordinatorDetailsProps {
  coordinatorProfileDetails: CoordinatorProfileResponseObject;
}

const CoordinatorDetails = ({ coordinatorProfileDetails }: CoordinatorDetailsProps) => {
  const { t } = useTranslation();

  return (
    <ContentTemplate type="full">
      <SectionHeader title={t('admin->>UserAccountManagement.AccountDetails')} />
      <Accordion defaultExpanded header={t('admin->>UserAccountManagement.PersonalParticulars')}>
        {coordinatorProfileDetails && (
          <CoordinatorPersonalParticulars
            coordinatorProfileDetails={coordinatorProfileDetails}
            isEditState={false}
          />
        )}
      </Accordion>

      <Accordion defaultExpanded header={t('admin->>UserAccountManagement.ContactInformation')}>
        {coordinatorProfileDetails && (
          <CoordinatorContactInformation
            coordinatorProfileDetails={coordinatorProfileDetails}
            isEditState={false}
          />
        )}
      </Accordion>
      <Box>
        <KeyValue
          keyText={t('admin->>UserAccountManagement.ExpirationDate')}
          valueText={
            coordinatorProfileDetails.expiryDate === undefined ||
            !coordinatorProfileDetails.expiryDate
              ? '-'
              : stringToSemanticDisplay(coordinatorProfileDetails?.expiryDate)
          }
        />
      </Box>
    </ContentTemplate>
  );
};

export default CoordinatorDetails;
